// extracted by mini-css-extract-plugin
module.exports = {"DownloadList":"DownloadList_DownloadList__nQIND"};